<div class="d-flex justify-content-between">
  <div>
    <p class="title"> <ng-content select="[title]" /> </p>
    <p class="subtitle"><ng-content select="[subtitle]" /></p>
  </div>
  @if (!onEditComment) {
  <div>
    <img src="../../../../../assets/images/icons/Icon_Notes.svg" class="edit" alt="Details" (click)="onFocus()" />
  </div>
  }
</div>

<span #commentbox class="textarea" role="textbox" contenteditable (input)="onInputChange($event)" (focus)="onFocus()"
  (blur)="onBlur()" [attr.data-content]="placeholder()" [innerText]="initialComment"
  [ngClass]="{'success': success}"></span>
<div class="d-flex label-field">
  @if (this.isServiceRequiringComment() && hasCommentLengthError) {
    <p class="required-field">{{'general-services.observation.service-need-observation.required' | translate }}</p>
  }

  @if (onEditComment) {
    <span class="counter">{{counter}}/500</span>
  }
</div>

@if (onEditComment && (isMobile || isFordPass)) {
<div class="d-flex justify-content-end">
  <button (click)="onBlur()" class="fmc-button" [disabled]="disableSaveButton">
    <ng-content select="[button-save]" />
  </button>
</div>
}
